export class DashboardCounters {

    expiredCount: number = 0
    expiringCount: number = 0
    activeCount: number = 0
    pendingCount: number = 0
    overdueTasksCount: number = 0
    pendingMarkoutRequestsCount: number = 0
    pendingProjectRequestsCount: number = 0

    constructor(data:any = null) {

        if(data === null) return

        this.expiredCount = data?.expiredCount ?? 0
        this.expiringCount = data?.expiringCount ?? 0
        this.activeCount = data?.activeCount ?? 0
        this.pendingCount = data?.pendingCount ?? 0
        this.overdueTasksCount = data?.overdueTasksCount ?? 0
        this.pendingMarkoutRequestsCount = data?.pendingMarkoutRequestsCount ?? 0
        this.pendingProjectRequestsCount = data?.pendingProjectRequestsCount ?? 0
    }

}